import { CheckableGroupComponent } from "./chunk-74SYDCTI.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioCardGroup/RadioCardGroup.Fields.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var RadioCardGroupFields = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent.Fields, __spreadValues({
    ref,
    className: clsx("pd:radio-card-group__fields", className)
  }, rest));
});
var RadioCardGroup_Fields_default = RadioCardGroupFields;
export { RadioCardGroup_Fields_default };